import { render, staticRenderFns } from "./NavTitle.vue?vue&type=template&id=06d2b3e6"
import script from "./NavTitle.vue?vue&type=script&lang=js"
export * from "./NavTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports